import React, { Component } from 'react'
import {capitalizeFirstLetter} from '../../util/StringUtil'

class PerformanceList extends Component {

  state = {
    edit: false,
    performance: '',
    performances: [
      'Mariages',
      'Divorces',
      'Bar Mitsvah',
      'Anniversaires',
      'Fêtes de quartier',
      'Fêtes de village',
      'Festivals',
      'Marathons',
      'Lotos sportifs',
      'Inaugurations',
      'Portes ouvertes de caves',
      'Carnavals',
      'Départs en retraite',
      'Mutations',
      'Décollages de soucoupes volantes'
    ]
  }

  edit = () => {
    this.setState({edit: true});
  }

  handleChange = (e) => {
    this.setState({performance: capitalizeFirstLetter(e.target.value)});
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      performances: [
        ...this.state.performances,
        this.state.performance],
      performance:'',
      edit:false
    });
  }

  render() {
    const InsertPerformance = () => {
      if(!this.state.edit) {
        return <span className="display-linebreak" onClick={this.edit}>- <b>&#91; Insérez votre prestation ici &#93;</b></span>
      } else {
        return <div>
          {/*<span className="display-linebreak">- {this.state.performance}</span>*/}
          <form action="" onSubmit={this.handleSubmit}>
            <div className="input-field input-introduction">
            {/*<label htmlFor="performance">Ajouter une nouvelle prestation</label>*/}
            - <input style={{width:'90%'}} autoFocus type="text" id="performance" onChange={this.handleChange} value={this.state.performance}/>
            </div>
          </form>
        </div>
      }
    }

    return (<span>
        {this.state.performances.map((performance, index) => <span key={index} className="display-linebreak">- {performance}</span>)}
        <InsertPerformance />
        </span>
    );
  }
}

export default PerformanceList;




/** WEBPACK FOOTER **
 ** ./src/components/Introduction/PerformanceList.js
 **/